module.exports = __webpack_public_path__ + "static/lc-logo-889f785a1fecc8dcb086c295c4112822.png";